import { Routes } from "@angular/router";

/**
 * Mango 22's list screen (PagedTableWrapperComponent) hides the top paginator and the list/chart tab bar and labels the
 * new-item button "Nieuw" by default. The Angular 12 app (Mango 4) had the paginator and tab bar and an icon-only button,
 * so every list route (also Mango's own groups and roles) gets those settings unless it sets them itself.
 */
export function withAngular12ListLook(list: Routes): Routes {
  return list.map(route => ({
    ...route,
    data: route.data?.collection ? { showTopPaginator: true, showTabBar: true, showNewItemLabel: false, ...route.data } : route.data,
    children: route.children ? withAngular12ListLook(route.children) : route.children,
  }));
}
